// extracted by mini-css-extract-plugin
export default {"heading":"modal_heading__iYwZo","modal":"modal_modal__5YaRz"};